// Home gateway module-card configuration, extracted from Home.vue so the (large)
// data structure + role gating is declarative and unit-testable. Pure: the builder
// takes the two role-derived routes and returns the module cards.

export const VACATION_ROLES = ["vacation-default", "vacation-user", "vacation-manager", "vacation-director", "vacation-hr"];
export const HR_ROLES = ["admin", "miniadmin", "vacation-hr"];
// Nota: crm-default (rol legacy din vechiul /Crm) NU e inclus — noul CRM /ncrm nu îl suportă
// la backend, deci nu-i arătăm cardul CRM (ar duce la un board cu 403). Vezi roleHelpers.
export const CRM_ROLES = ["admin", "miniadmin", "crm-admin", "crm-operator", "crm-caller"];
export const AI_ROLES = ["admin", "miniadmin", "ai-default"];
export const CRM_NEW_APP_ROLES = ["admin", "miniadmin", "crm-admin", "crm-operator"];
export const CRM_LEAD_ROLES = [...new Set([...CRM_NEW_APP_ROLES, "crm-caller", "caller"])];

export const buildHomeModules = ({ crmRoute, personnelRoute }) => [
  {
    id: "ai",
    moduleKey: null,
    titleKey: "home.cards.ai.title",
    subtitleKey: "home.cards.ai.subtitle",
    ctaKey: "home.cards.ai.cta",
    route: "/ai-workspace",
    icon: "mdi-robot-outline",
    roles: AI_ROLES,
    quickLinks: [
      { id: "ai-review", route: { path: "/ai-workspace", query: { tab: "review" } }, labelKey: "home.quickLinks.aiReview", roles: AI_ROLES },
      { id: "ai-runs", route: { path: "/ai-workspace", query: { tab: "runs" } }, labelKey: "home.quickLinks.aiRuns", roles: AI_ROLES },
      { id: "ai-settings", route: { path: "/ai-workspace", query: { tab: "settings" } }, labelKey: "home.quickLinks.aiSettings", roles: AI_ROLES },
    ],
  },
  {
    id: "crm",
    moduleKey: "crm",
    titleKey: "home.cards.crm.title",
    subtitleKey: "home.cards.crm.subtitle",
    ctaKey: "home.cards.crm.cta",
    ctaColor: "primary",
    quickLinkColor: "primary",
    route: crmRoute,
    icon: "mdi-briefcase-outline",
    roles: CRM_ROLES,
    quickLinks: [
      { id: "crm-contacts", route: "/ncrm/contacts", labelKey: "home.quickLinks.crmContacts", roles: CRM_NEW_APP_ROLES },
      { id: "crm-lead", route: "/ncrm/leads", labelKey: "home.quickLinks.crmLead", roles: CRM_LEAD_ROLES },
      { id: "crm-deal", route: "/ncrm/deals", labelKey: "home.quickLinks.crmDeal", roles: CRM_NEW_APP_ROLES },
      { id: "crm-contracts", route: "/ncrm/contracts", labelKey: "home.quickLinks.crmContracts", roles: CRM_NEW_APP_ROLES },
      { id: "crm-products", route: "/ncrm/products", labelKey: "home.quickLinks.crmProducts", roles: CRM_NEW_APP_ROLES },
    ],
  },
  {
    id: "vacation",
    moduleKey: "hr-core",
    titleKey: "home.cards.vacation.title",
    subtitleKey: "home.cards.vacation.subtitle",
    ctaKey: "home.cards.vacation.cta",
    ctaColor: "primary",
    quickLinkColor: "primary",
    route: personnelRoute,
    icon: "mdi-clipboard-account",
    roles: [...new Set([...VACATION_ROLES, ...HR_ROLES])],
    quickLinks: [
      { id: "company-board", route: { path: "/hr-dashboard", query: { option: "company-board" } }, labelKey: "home.quickLinks.companyBoard", roles: HR_ROLES },
      { id: "my-data", route: "/me", labelKey: "home.quickLinks.myData", roles: [...new Set([...VACATION_ROLES, ...HR_ROLES])] },
      { id: "checklist-management", route: { path: "/hr-dashboard", query: { option: "checklist" } }, labelKey: "home.quickLinks.checklistManagement", roles: HR_ROLES },
    ],
  },
  {
    id: "admin",
    moduleKey: null,
    titleKey: "home.cards.admin.title",
    subtitleKey: "home.cards.admin.subtitle",
    ctaKey: "home.cards.admin.cta",
    route: "/admin/contracts",
    icon: "mdi-shield-crown-outline",
    roles: ["admin"],
    quickLinks: [
      { id: "admin-contracts", route: "/admin/contracts", labelKey: "home.quickLinks.adminContracts", roles: ["admin"] },
      { id: "admin-analytics", route: "/admin/analytics", labelKey: "home.quickLinks.adminAnalytics", roles: ["admin"] },
      { id: "admin-workflows", route: "/admin/workflows", labelKey: "home.quickLinks.adminWorkflows", roles: ["admin"] },
      { id: "admin-online-users", route: "/admin/online-users", labelKey: "home.quickLinks.adminOnlineUsers", roles: ["admin"] },
    ],
  },
];
